import ApiService from "./ApiService";
import { format } from "util";

const ENDPOINTS = {
    GET_NOTIFICATIONS: "/notifications/",
    SET_ALL_NOTIFICATIONS: "/notifications/toggle_config/",
    UPDATE_SINGLE_NOTIFICATION: "/notifications/%s/",
    SET_CUSTOM_MESSAGE: "/notifications/%s/message/"
};

class NotificationService extends ApiService {
    getNotifications = () => {
        return this.apiClient.get(format(ENDPOINTS.GET_NOTIFICATIONS));
    };

    updateAllNotifications = (payload) => {
        return this.apiClient.put(format(ENDPOINTS.SET_ALL_NOTIFICATIONS), payload);
    }

    updateSingleNotification = (payload) => {
        return this.apiClient.put(format(ENDPOINTS.UPDATE_SINGLE_NOTIFICATION, payload.id), payload);
    }

    setCustomMessage = (payload) => {
        return this.apiClient.put(format(ENDPOINTS.SET_CUSTOM_MESSAGE, payload.notification_id), payload);
    }
}

export default new NotificationService();